import { useState } from "react";
import styles from "../styles/AnalyticsView.module.css";
import StatisticsTab from "./AnalyticsPages/StatisticsTab";
import SoldProductsTab from "./AnalyticsPages/SoldProductsTab";
import IncomeProductsTab from "./AnalyticsPages/IncomeProductsTab";
import StockProductsTab from "./AnalyticsPages/StockProductsTab";


const AnalyticsView = () => {
  const [activeSection, setActiveSection] = useState("statistics");

  const sections = [
    { id: "statistics", label: "Статистика" },
    { id: "sold", label: "Продаваемые товары" },
    { id: "income", label: "Доходные товары" },
    { id: "stock", label: "Остатки товаров" },
  ];

  const renderSection = () => {
    switch (activeSection) {
      case "statistics":
        return <StatisticsTab />;
      case "sold":
        return <SoldProductsTab />;
      case "income":
        return <IncomeProductsTab />;
      case "stock":
        return <StockProductsTab />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {sections.map((section) => (
          <button
            key={section.id}
            className={`${styles.tabButton} ${
              activeSection === section.id ? styles.active : ""
            }`}
            onClick={() => setActiveSection(section.id)}
          >
            {section.label}
          </button>
        ))}
      </div>

      <div className={styles.content}>{renderSection()}</div>
    </div>
  );
};

export default AnalyticsView;
